import React from 'react';
import { Button as AntButton } from 'antd';
import PropTypes from 'prop-types';

const Button = ({ label, ...rest }) => {
  return (
    <>
      <AntButton {...rest}>{label}</AntButton>
    </>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
};

export default Button;
